import * as R from "ramda";
const STRUCTURE_DIMENSION_LIST_PATH = [
  "data",
  "dataStructures",
  0,
  "dataStructureComponents",
  "dimensionList"
];
const STRUCTURE_DIMENSIONS_PATH = R.append(
  "dimensions",
  STRUCTURE_DIMENSION_LIST_PATH
);
R.concat(
  STRUCTURE_DIMENSION_LIST_PATH,
  ["timeDimensions", 0]
);
const FREQUENCY_IDS = ["FREQ", "FREQUENCY"];
const TIME_PERIOD_ROLE = "TIME_PERIOD";
const TIME_PERIOD_ID = "TIME_PERIOD";
const REF_AREA_ROLES = ["GEO", "REF_AREA"];
const REF_AREA_IDS = [
  "REF_AREA",
  "COUNTRY",
  "LOCATION",
  "REGION",
  "REFERENCE_AREA"
];
export {
  FREQUENCY_IDS,
  REF_AREA_IDS,
  REF_AREA_ROLES,
  STRUCTURE_DIMENSIONS_PATH,
  STRUCTURE_DIMENSION_LIST_PATH,
  TIME_PERIOD_ID,
  TIME_PERIOD_ROLE
};
